<template>
  <div class="notifications" v-show="isActive">
    <div v-if="this.notifications.length===0">
      <div class="text-center no-item">
        <img class="pb-3" src="~@/assets/images/no-notification.svg" alt="No notifications" />
        <p class="no-notification">There are no notifications</p>
      </div>
    </div>
    <div v-else  class="notification" :class="{ new: notification.NewNotification }" v-for="notification in notifications.slice(0, 10)" :key="notification.Id">
      <!-- <div :class="{ new: notification.NewNotification }"> -->
        <div class="row">
          <div class="item col-8 col-md-10">
            <i
              v-show="notification.NewNotification"
              class="fas fa-circle fa-xs pr-2"
            ></i>
            <h3 tabindex="0">{{ notification.Title }}</h3>
          </div>
          <div class="item col-4 col-md-2 date">{{ convertDate(notification.LastPublished) }}</div>
        </div>
        <div class="row">
          <div class="item intro col-12 col-md-10" v-html="notification.Introduction"></div>
          <div class="item col-12 col-md-2"> <a role="button"
          class="view"
          v-if="notification.LinkUrl"
          :href="notification.LinkUrl"
          :target="notification.LinkTarget"
          @click="saveViewedNotification(notification.Id)"
          @keydown.enter="saveViewedNotification(notification.Id)"
          tabindex="0"
        >View <span class="angle-right-green"></span>
          <!-- {{ notification.LinkText }} -->
        </a></div>
        </div>
      <!-- </div> -->
    </div>
    


    <div v-show="!showOlderNotifications" @click="showOlderNotifications = true" @keydown.enter="showOlderNotifications = true" v-if="notifications.length > 10" class="p-3"><a class="view" tabindex="0">View older notifications</a></div>
    <div v-show="showOlderNotifications"  class="notification" :class="{ new: notification.NewNotification }" v-for="notification in notifications.slice(10)" :key="notification.Id">
      <!-- <div :class="{ new: notification.NewNotification }"> -->
        <div class="row">
          <div class="item col-8 col-md-10">
            <i
              v-show="notification.NewNotification"
              class="fas fa-circle fa-xs pr-2"
            ></i>
            <h3 tabindex="0">{{ notification.Title }}</h3>
          </div>
          <div class="item col-4 col-md-2 date">{{ convertDate(notification.LastPublished) }}</div>
        </div>
        <div class="row">
          <div class="item intro col-12 col-md-10" v-html="notification.Introduction"></div>
          <div class="item col-12 col-md-2"> <a role="button"
          class="view"
          v-if="notification.LinkUrl"
          :href="notification.LinkUrl"
          :target="notification.LinkTarget"
          @click="saveViewedNotification(notification.Id)"
          @keydown.enter="saveViewedNotification(notification.Id)"
        >View <span class="angle-right-green"></span>
          <!-- {{ notification.LinkText }} -->
        </a></div>
        </div>
      <!-- </div> -->
    </div>
    <div class="space"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { SAVE_NOTIFICATIONACTION } from "../store/mutation-types";
import moment from "moment";

export default {
  name: "OverviewNotifications",
  data() {
    return {
      isActive: true,      
      showOlderNotifications: false
    };
  },
  async created() {  
    await this.notifications.forEach(notification => {
      if (notification.NewNotification && !notification.LinkUrl) {
        // notifications without a link are updated as 'viewed' immediately
        this.saveViewedNotification(notification.Id);
      }
    });
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    ...mapActions([SAVE_NOTIFICATIONACTION]),
    async saveViewedNotification(notificationId) {
      await this.saveNotificationAction(notificationId);
    },
    convertDate(date) {
      return moment(date).format('DD/MM/YY')
    }
  }
  /*computed: {
            ...mapState({ notifications: 'notifications' })
        } */
};
</script>

<style lang="sass" scoped></style>
